import { CartState } from 'b2b-apps/shop/cart/redux/cart/types';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { AddItemsToCartType, CartProductType, CartType, WishlistWithAddedCartType } from 'b2b-common/core/cart/api/CartTypes';

const getState = (state: State): CartState => state.cart.cart;

const getAddCartToWishlistData = (
  state: State,
): RemoteRecord<WishlistWithAddedCartType> => new RemoteRecord(getState(state).addCartToWishlist);

const getCart = (state: State): RemoteRecord<CartType> => new RemoteRecord(getState(state).cartData);

const getCartProductCount = (state: State): number => {
  const cart = getCart(state);
  let count = 0;

  if (cart.data) {
    const { products } = cart.data;

    if (Array.isArray(products)) {
      products.forEach((product) => {
        count += product.cart.quantity;
      });
    }
  }

  return count;
};

const getCartProductBySku = (
  state: State,
  sku: string,
): CartProductType | null | undefined => {
  const cart = getCart(state);

  if (!cart.data) {
    return;
  }

  return cart.data.products.find(
    (product: CartProductType): boolean => product.sku === sku,
  );
};

const getCartLicensedProducts = (state: State): CartProductType[] => {
  const cart = getCart(state);

  if (cart.isLoaded && cart.data && cart.data.products) {
    return cart.data.products.filter(
      (product) => product.settings.requiresLicense,
    );
  }

  return [];
};

const getAddItemsToCartData = (
  state: State,
): RemoteRecord<AddItemsToCartType> => new RemoteRecord(getState(state).addItems);

export {
  getAddCartToWishlistData,
  getAddItemsToCartData,
  getCart,
  getCartLicensedProducts,
  getCartProductBySku,
  getCartProductCount,
  getState,
};
